export const CHILD_SUPPORT_TEMPLATES_CONTAINER_TAG_NAME = 'child-support-templates-container';
